import React from 'react';
import { BookOpen, Car, FileText } from 'lucide-react';
import { Button } from './ui/Button';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function BundleSection() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  const products = [{
    icon: <BookOpen className="w-8 h-8 text-deep-blue" data-id="element-16" />,
    title: 'Manual Maestro Protocolo Cero Gritos',
    value: '27€',
    isMain: true
  }, {
    icon: <Car className="w-8 h-8 text-warm-accent" data-id="element-17" />,
    title: 'BONO SOS: Berrinches en el Súper',
    value: '17€',
    isBonus: true
  }, {
    icon: <FileText className="w-8 h-8 text-warm-accent" data-id="element-18" />,
    title: 'BONO: Guía de Frases Exactas',
    value: '17€',
    isBonus: true
  }];
  return <section id="pricing" className="py-10 px-4 bg-cream" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <div className="text-center mb-6" data-id="element-21">
          <h2 className="text-4xl md:text-5xl font-bold text-deep-blue mb-4" data-id="element-22">
            Todo lo que necesitas para recuperar la paz
          </h2>
          <p className="text-xl text-deep-blue/70" data-id="element-23">
            Un paquete diseñado para resultados rápidos, no para acumular polvo
            digital.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-24">
          {products.map((product, index) => <div key={index} className={`bg-white rounded-3xl p-8 shadow-sm border ${product.isMain ? 'border-deep-blue/20 ring-1 ring-deep-blue/10' : 'border-gray-100'} flex flex-col h-full relative overflow-hidden`} data-id="element-25">
              {product.isBonus && <div className="absolute top-4 right-4 bg-mint-light text-mint-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-26">
                  Bono Gratis
                </div>}
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 ${product.isMain ? 'bg-deep-blue/5' : 'bg-cream'}`} data-id="element-27">
                {product.icon}
              </div>
              <h3 className="text-xl font-bold text-deep-blue mb-6 flex-grow" data-id="element-28">
                {product.title}
              </h3>
              <div className="pt-6 border-t border-gray-100 flex justify-between items-center" data-id="element-29">
                <span className="text-sm text-deep-blue/50 font-medium" data-id="element-30">
                  Valor real
                </span>
                <span className="font-bold text-deep-blue line-through opacity-50" data-id="element-31">
                  {product.value}
                </span>
              </div>
            </div>)}
        </div>

        {/* Pricing Summary Box */}
        <div className="bg-white border-2 border-dashed border-warm-accent/40 rounded-3xl p-8 md:p-12 text-center shadow-xl max-w-3xl mx-auto relative overflow-hidden" data-id="element-32">
          <div className="absolute top-0 left-0 w-full h-2 bg-warm-accent" data-id="element-33"></div>

          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-deep-blue" data-id="element-34">
            Resumen de tu inversión hoy
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-6" data-id="element-35">
            <div className="text-center" data-id="element-36">
              <p className="text-sm text-deep-blue/60 uppercase tracking-wider mb-1 font-bold" data-id="element-37">
                Valor Total
              </p>
              <p className="text-3xl font-bold text-deep-blue/40 line-through" data-id="element-38">
                61€
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-gray-200" data-id="element-39"></div>
            <div className="text-center" data-id="element-40">
              <p className="text-sm text-warm-accent uppercase tracking-wider mb-1 font-bold" data-id="element-41">
                Hoy Solo
              </p>
              <p className="text-6xl font-black text-deep-blue" data-id="element-42">6,95€</p>
            </div>
          </div>

          <div className="flex justify-center mb-6" data-id="element-43">
            <Button onClick={goToCheckout} className="animate-pulse-soft w-full md:w-auto" data-id="element-44">
              CONSEGUIR MANUAL + 2 BONOS AHORA
            </Button>
          </div>

          <p className="text-deep-blue/70 font-medium flex items-center justify-center gap-2" data-id="element-45">
            ☕ Menos de lo que cuesta un café para dos hoy.
          </p>
        </div>
      </div>
    </section>;
}